import { useState } from "react";
import { useActiveTenant } from "../tenant/TenantContext";
import { useTenantMutation, useTenantQuery } from "../hooks/useTenantData";
import { can } from "../tenant/permissions";
import type { Device } from "../api/types";
import {
  Badge,
  ConfirmDialog,
  InlineError,
  PageHeader,
  Panel,
  QueryState,
} from "../components/ui";

export function DevicesPage() {
  const membership = useActiveTenant();
  const canRevoke = can(membership.role, "devices.revoke");
  const devices = useTenantQuery(["devices"], (api, t) => api.listDevices(t));
  const [revoking, setRevoking] = useState<Device | null>(null);

  const revoke = useTenantMutation<string>(
    (api, t, id) => api.revokeDevice(t, id),
    [["devices"], ["audit-events"]],
  );

  return (
    <>
      <PageHeader
        title="Dispositivos"
        subtitle="Aparelhos com o App AVA ativado neste condomínio. Revogue em caso de perda ou troca."
      />
      <Panel title="Aparelhos registrados">
        <QueryState query={devices} empty="Nenhum aparelho ativado ainda.">
          {(items) => (
            <div className="table">
              {items.map((device) => (
                <div className="table-row" key={device.id}>
                  <span>
                    <strong>{device.name}</strong>
                    <small>
                      {device.person_name} · {device.unit_labels.join(", ")} ·{" "}
                      {device.platform === "ios" ? "iOS" : "Android"}
                    </small>
                    <small>
                      Último contato:{" "}
                      {device.last_seen_at ? new Date(device.last_seen_at).toLocaleString("pt-BR") : "nunca"}
                    </small>
                  </span>
                  <Badge tone={device.active ? "ok" : "muted"}>{device.active ? "Ativo" : "Revogado"}</Badge>
                  {canRevoke && device.active && (
                    <span className="row-actions">
                      <button type="button" className="danger" onClick={() => setRevoking(device)}>
                        Revogar
                      </button>
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </QueryState>
        <InlineError error={revoke.error} />
      </Panel>
      <ConfirmDialog
        open={revoking !== null}
        title="Revogar dispositivo"
        description={
          revoking
            ? `Revogar "${revoking.name}" de ${revoking.person_name}? O aparelho para de receber chamadas imediatamente e uma nova ativação exigirá um novo convite.`
            : ""
        }
        confirmLabel="Revogar dispositivo"
        busy={revoke.isPending}
        onCancel={() => setRevoking(null)}
        onConfirm={() => {
          if (revoking) revoke.mutate(revoking.id, { onSettled: () => setRevoking(null) });
        }}
      />
    </>
  );
}
